/**
 * Deterministic Guid constants matching backend SubStatusParameterGuids (EtlGuid).
 *
 * Otoriter kaynak: services/Wiser-ATS-BE/Data/Seeding/Sql/system/030_SubStatusParameter.sql
 * Degerler uuid5(NAMESPACE_DNS, "SubStatusParameter:<legacyId>") ile uretilir.
 * Dogrulama: python scripts/audit_fe_guid_constants.py
 */
export const SubStatusParameterGuids = {
  ikGorusme1: "45696629-0fd1-52cd-8c96-9e46e58a52c4",
  ikGorusme2: "76f4fb3f-e187-5608-9d39-7c2e6d68f7e3",
  telGorusme: "91f36bd8-7e1e-5dc3-8f3e-a96c47050a2a",
  musteriGorusme1: "1966c5f4-64db-504c-ac6f-2d2c55442de4",
  musteriGorusme2: "3cb2ff5d-f9f2-5b5d-93fd-45e799af5dea",
  musteriGorusme3: "fdb82d3e-67d2-5253-987f-a25cfb245197",
  musteriGorusme4: "b14af389-cbd3-58d1-b97c-2de0bdb4c802", // 32 MÜŞ. GÖRÜŞME 4
  teklif: "5133dfb0-50dd-55b8-832d-d77944bac890",
  yonlendirildi: "28f97afa-1931-5e4f-887f-245954da06d7",
  linkedin: "a04b5f1e-a317-56a5-bd98-a228c68ed2de",
  red: "b08337aa-422b-546e-a96a-e15963b932da", // 19 RED
  aday: "b3a2ab88-efd1-5fd7-a83e-da5dd6a106f3", // 18 ADAY
  longlist: "5a85a5a5-c6b5-548f-a73a-99acc9fc511c", // 29 LONGLİST
  partneraYonlendirildi: "fa5ad0c9-abac-5fdf-b9de-d2ee84bf9fad", // 25 PARTNER
  talentaYonlendirildi: "b4a62b12-6be8-5103-8362-28bb125ec23b", // 30 TALENT
  musteriGorusmeTalebi: "0e4318b4-212a-5908-a9e2-061aef0e4624", // 31 MÜŞTERİ GÖRÜŞME TALEBİ
  durumGuncelleme: "47f8b5ca-aaa5-5791-b4f2-cf6ff23e3538", // 27 DURUM GÜNCELLEME
} as const;

export type SubStatusGuid =
  (typeof SubStatusParameterGuids)[keyof typeof SubStatusParameterGuids];

const S = SubStatusParameterGuids;

/** LinkedIn veya tel. görüşme — deneyim/kaynak alanları gösterilir. */
export const subStatusLinkedinOrTel: readonly string[] = [
  S.linkedin,
  S.telGorusme,
];

/** İK / müşteri görüşmesi / teklif — geniş form alanı seti. */
export const subStatusExtendedForm: readonly string[] = [
  S.ikGorusme1,
  S.ikGorusme2,
  S.musteriGorusme1,
  S.musteriGorusme2,
  S.musteriGorusme3,
  S.musteriGorusme4,
  S.teklif,
];

/** İlgili uzman alanı gösterilir. (upstream b513a8e ile MÜŞ. GÖRÜŞME 3-4 eklendi) */
export const subStatusWithRelevantExpert: readonly string[] = [
  S.ikGorusme1,
  S.ikGorusme2,
  S.musteriGorusme1,
  S.musteriGorusme2,
  S.musteriGorusme3,
  S.musteriGorusme4,
  S.teklif,
];

/** Müşteri görüşmesi — relatedId / interviewMemberId alanları. */
export const subStatusWithRelatedContact: readonly string[] = [
  S.musteriGorusme1,
  S.musteriGorusme2,
  S.musteriGorusme3,
  S.musteriGorusme4,
];

/** Müşteri görüşmesi aşamaları (tümü). */
export const subStatusCustomerInterview: readonly string[] = [
  S.musteriGorusme1,
  S.musteriGorusme2,
  S.musteriGorusme3,
  S.musteriGorusme4,
];

/** İK görüşmesi — ilgili uzman personnel listesinden seçilir. */
export const subStatusRelevantExpertIk: readonly string[] = [
  S.ikGorusme1,
  S.ikGorusme2,
];

/** Müşteri görüşmesi — ilgili uzman active IK listesinden seçilir. (b513a8e: 3-4 eklendi) */
export const subStatusRelevantExpertCustomer: readonly string[] = [
  S.musteriGorusme1,
  S.musteriGorusme2,
  S.musteriGorusme3,
  S.musteriGorusme4,
];

/** İlgili uzman alanı zorunlu alt durumlar. (b513a8e: 3-4 eklendi) */
export const subStatusRelevantExpertRequired: readonly string[] = [
  S.musteriGorusme1,
  S.musteriGorusme2,
  S.musteriGorusme3,
  S.musteriGorusme4,
  S.teklif,
];

/** Şirket/müşteri/pozisyon/tarih zorunlu aday durumları. */
export const subStatusCandidateForm: readonly string[] = [
  S.aday,
  S.longlist,
  S.partneraYonlendirildi,
  S.talentaYonlendirildi,
  S.musteriGorusmeTalebi,
  S.durumGuncelleme,
];

/*
 * KALDIRILDI: filteredNegativeReasonIdsBySubStatus
 *
 * Bu harita LEGACY INT olumsuz-neden id'leri tutuyordu ve tek tuketicisi
 * (StatusFormModal) `?.includes(Number(reason.id))` ile karsilastiriyordu.
 * GET api/Data/GetNegativeReasonsList ise GUID donduruyor
 * (GenerelParameterDTO.id -> Guid), yani Number("e31855d7-...") === NaN ve
 * filtre HICBIR ZAMAN eslesmiyordu: IK / LinkedIn / Tel. Gorusme alt
 * durumlarinda olumsuz neden listesi CANLI ORTAMDA BOS geliyordu
 * (playbook tuzak #1). Upstream'de bu hata YOK; bizim Guid gecisimizin
 * kalintisi. Bkz. docs/repo-migration/NOT_PORTED.md §5.
 *
 * Guid karsiligi `negativeReasonIdsBySubcase`
 * (src/constants/negativeReasonParameterGuids.ts) zaten vardi ve
 * InterviewAssistant onu kullaniyordu; StatusFormModal da artik ona bagli.
 */

/** Görüşme asistanı — İK / tel. görüşme aşamaları. */
export const subStatusIkInterviewAssistant: readonly string[] = [
  S.ikGorusme1,
  S.ikGorusme2,
  S.telGorusme,
];

/** Görüşme asistanı — müşteri görüşmesi aşamaları (IsInsource müşteri ile). */
export const subStatusCustomerInterviewAssistant: readonly string[] = [
  S.musteriGorusme1,
  S.musteriGorusme2,
  S.musteriGorusme3,
  S.musteriGorusme4,
];

/**
 * Yönlendirme alt durumları — backend'deki `SubStatusParameterGuids.RedirectStatuses`
 * ile birebir aynı küme.
 *
 * Çoklu şirketli kurulumda bu alt durumlarda **hedef şirket** sorulur: hedefi
 * adında taşıyan alt durumlarda (Partner'a / Talent'a) değer alt durumun kendi
 * yapılandırmasından gelir, hedefsiz jenerik "Yönlendirildi"de kullanıcı seçer.
 * Bkz. MULTITENANCY_RDC_COUPLING.md §12.7.
 */
export const subStatusRedirect: readonly string[] = [
  S.yonlendirildi,
  S.partneraYonlendirildi,
  S.talentaYonlendirildi,
];

/**
 * Manuel skor alanı gösterilir/zorunludur. (upstream ded1c92 → 9bd8061)
 * Yönlendirme aileleri; ayrıca mülakat sonucu "olumsuz" ise de zorunludur.
 */
export const subStatusWithManuelScore: readonly string[] = [
  S.yonlendirildi,
  S.partneraYonlendirildi,
  S.talentaYonlendirildi,
];

/**
 * Mülakat sonucu "olumsuz" ise manuel skor isteyen alt durumlar (upstream 8834423).
 * Önceden koşul alt durumdan bağımsızdı: HERHANGİ bir alt durumda "olumsuz" seçilince
 * manuel skor zorunlu oluyordu. Artık yalnızca İK görüşmelerinde.
 * Tel. Görüşme dahil değil — BE `RequiresManuelScore` ile aynı (ExtensionService.StateRules).
 */
export const subStatusManuelScoreOnNegative: readonly string[] = [
  S.ikGorusme1,
  S.ikGorusme2,
];

/*
 * KALDIRILDI: subStatusNegativeReasonHidden
 *
 * Upstream 5a8f50f gorunurluk kuralini TERSINE CEVIRDI. Eski kural "su alt
 * durumlarda GIZLE" idi; yeni kural "yalnizca haritada karsiligi olanlarda
 * GOSTER" (negativeReasonParameterGuids.isNegativeReasonSubStatus). "Gizli
 * liste" yaklasimi artik anlamsiz -- listede olmayan yeni bir alt durum
 * eklendiginde alan sessizce gorunur ve zorunlu olurdu.
 */

/**
 * İleri mülakat tarihi girilemeyen alt durumlar (upstream 7658949
 * `ValidateFutureInterviewDate`; BE karşılığı StateInfoService.Mutation.cs
 * aynı üç alt durumu kontrol ediyor).
 */
export const subStatusNoFutureInterviewDate: readonly string[] = [
  S.telGorusme,
  S.linkedin,
  S.yonlendirildi,
];

export const isSubStatusIn = (
  subStatusId: string | null | undefined,
  group: readonly string[],
): boolean =>
  !!subStatusId && group.includes(subStatusId);
